import AgreementFieldEditor from './AgreementFieldEditor.component';

export default AgreementFieldEditor;
